import { FC } from 'react';
import { useField } from 'formik';

import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import Section from 'components/Section';
import TransportTypeRadioGroup from 'components/TransportTypeRadioGroup';
import TextField from 'components/TextField';

import { TransportType } from '__generated__/PackageEditMainFormMutation.graphql';
import Checkbox from 'components/Checkbox';

const PackageEditTransportGeneral: FC = () => {
  const [{ value }] = useField<TransportType>('transportType');

  return (
    <Section id="general" title="Bendra informacija">
      <Stack spacing={4}>
        <TransportTypeRadioGroup name="transportType" />

        {value === 'PLANE' && (
          <FormControlLabel
            control={<Checkbox name="externalFlights" sx={{ ml: '-9px' }} />}
            label="Skrydžiai išorinio tiekėjo"
          />
        )}

        <TextField fullWidth name="transportName" label="Vežėjas" />
      </Stack>
    </Section>
  );
};

export default PackageEditTransportGeneral;
